import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('TicketFilter')
export class TicketFilter extends Entity {
  @JsonProperty('caseNumber', [String])
  public caseNumber: string[] = [];
  @JsonProperty('serialNumber', [String])
  public serialNumber: string[] = [];
  @JsonProperty('errorMessage', [String])
  public errorMessage: string[] = [];
  @JsonProperty('order_by', [String])
  public orderBy: string[] = [];
  @JsonProperty('direction', [String])
  public direction: string[] = [];
}
